export const onlyNumber = /^[0-9]$/;

export const filterValidNumber = (value: unknown) => {
  return typeof value !== 'string' || !onlyNumber.test(value);
};
